import { createFileRoute } from '@tanstack/react-router'
import SystemSettingsPage from '@/spa/pages/SystemSettingsPage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/system-settings')({
  component: SystemSettingsPage,
  errorComponent: routeErrorComponent,
})
